const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

/**
 * True when the value points at a real stored file.
 * The API serializes a missing non-nullable Guid as the all-zero GUID, which is truthy as a string.
 */
export function hasFileId(fileId: unknown): fileId is string {
  if (typeof fileId !== 'string') return false;
  const id = fileId.trim().toLowerCase();
  return id !== '' && id !== EMPTY_GUID;
}

/** The file id itself, or undefined when the value does not point at a real stored file. */
export function fileIdOrUndefined(fileId: unknown): string | undefined {
  return hasFileId(fileId) ? fileId : undefined;
}
